import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/* LOT 63 · V12 · un lien interne ne recharge jamais l'app : la navigation reste dans la page */
export const LiensInternes = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const f = (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest?.('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download') || a.dataset.recharge !== undefined) return;
      const u = new URL(a.href, window.location.href);
      if (u.origin !== window.location.origin || u.pathname.startsWith('/api/') || /\.(pdf|png|jpe?g|csv|xlsx|zip)$/i.test(u.pathname)) return;
      e.preventDefault();
      navigate(`${u.pathname}${u.search}${u.hash}`);
    };
    document.addEventListener('click', f);
    return () => document.removeEventListener('click', f);
  }, [navigate]);
  return null;
};
